import React from 'react';
import { useCookieConsent } from '../contexts/CookieContext';

interface ConsentGuardProps {
  children: React.ReactNode;
  type?: 'analytics' | 'externalMedia';
  title: string;
}

const ConsentGuard: React.FC<ConsentGuardProps> = ({ 
  children, 
  type = 'externalMedia', 
  title 
}) => {
  const { consent, setShowBanner } = useCookieConsent();

  const hasConsent = consent ? (type === 'analytics' ? consent.analytics : consent.externalMedia) : false;

  if (hasConsent) {
    return <>{children}</>;
  }

  return (
    <div className="bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg p-8 flex flex-col items-center justify-center text-center space-y-4 my-4">
      <div className="p-3 bg-blue-50 rounded-full">
        <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
        </svg>
      </div>
      <div>
        <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
        <p className="text-sm text-gray-600 mt-1 max-w-md">
          Dieser Inhalt wird von einem Drittanbieter geladen. Um ihn anzuzeigen, müssen Sie der Verwendung von externen Medien zustimmen.
        </p>
      </div>
      <button
        onClick={() => setShowBanner(true)}
        className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      >
        Einstellungen anpassen
      </button>
    </div>
  );
};

export default ConsentGuard;



